if(!customElements.get("product-form")){let removeElementsByScreenSize2=function(container=document){window.matchMedia("(max-width: 990px)").matches?(document.querySelectorAll(".hide-mobile").forEach(el=>{removedElements.desktop.push({parent:el.parentNode,element:el,nextSibling:el.nextSibling}),el.remove()}),removedElements.mobile.forEach(({parent,element,nextSibling})=>{nextSibling&&nextSibling.parentNode===parent?parent.insertBefore(element,nextSibling):parent.appendChild(element)}),removedElements.mobile=[]):(document.querySelectorAll(".hide-desktop").forEach(el=>{removedElements.mobile.push({parent:el.parentNode,element:el,nextSibling:el.nextSibling}),el.remove()}),removedElements.desktop.forEach(({parent,element,nextSibling})=>{nextSibling&&nextSibling.parentNode===parent?parent.insertBefore(element,nextSibling):parent.appendChild(element)}),removedElements.desktop=[])};var removeElementsByScreenSize=removeElementsByScreenSize2;customElements.define("product-form",class extends HTMLElement{constructor(){if(super(),this.form=this.querySelector("form"),this.form.querySelector("[name=id]").disabled=!1,this.form.addEventListener("submit",this.onSubmitHandler.bind(this)),this.cart=document.querySelector("cart-notification")||document.querySelector("cart-drawer"),this.submitButton=this.querySelector('[type="submit"]'),this.checkoutButton=this.querySelector("[data-checkout-url]"),this.clickedSubmitButton=null,this.pending=!1,this.querySelectorAll('[type="submit"]').forEach(button=>{button.addEventListener("click",()=>{this.clickedSubmitButton=button})}),this.checkoutButton){const syncCheckoutButtonState=()=>{const disabled=this.submitButton.disabled||this.submitButton.getAttribute("aria-disabled")==="true";this.checkoutButton.disabled=disabled,disabled?this.checkoutButton.setAttribute("aria-disabled","true"):this.checkoutButton.removeAttribute("aria-disabled")};syncCheckoutButtonState(),this.checkoutButtonObserver=new MutationObserver(syncCheckoutButtonState),this.checkoutButtonObserver.observe(this.submitButton,{attributes:!0,attributeFilter:["disabled","aria-disabled"]})}document.querySelector("cart-drawer")&&this.submitButton.setAttribute("aria-haspopup","dialog")}refreshCartSections(){if(!this.cart)return Promise.resolve();const sectionIds=this.cart.getSectionsToRender().map(s=>s.id).join(","),url=`${window.routes.cart_url}?sections=${sectionIds}&sections_url=${encodeURIComponent(window.location.pathname)}`;return fetch(url,{headers:{"X-Requested-With":"XMLHttpRequest"}}).then(r=>r.json()).then(sections=>{this.cart.renderContents({sections}),publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form"})}).catch(e=>console.error(e))}onSubmitHandler(evt){evt.preventDefault();const submitButton=evt.submitter||this.clickedSubmitButton||this.submitButton,checkoutUrl=submitButton.dataset.checkoutUrl;if(this.clickedSubmitButton=null,this.pending||submitButton.disabled||submitButton.getAttribute("aria-disabled")==="true")return;this.pending=!0,this.handleErrorMessage(),submitButton.setAttribute("aria-disabled",!0);const config=fetchConfig("javascript");config.headers["X-Requested-With"]="XMLHttpRequest",delete config.headers["Content-Type"];const formData=new FormData(this.form);this.cart&&(formData.append("sections",this.cart.getSectionsToRender().map(section=>section.id)),formData.append("sections_url",window.location.pathname),this.cart.setActiveElement(document.activeElement)),config.body=formData,fetch(`${routes.cart_add_url}`,config).then(response=>response.json()).then(response=>{if(response.status){this.handleErrorMessage(response.description);const soldOutMessage=submitButton.querySelector(".sold-out-message");if(soldOutMessage&&(submitButton.setAttribute("aria-disabled",!0),submitButton.querySelector("span")?.classList.add("hidden"),soldOutMessage.classList.remove("hidden")),this.error=!0,!this.cart){const cartUrl=window.routes?.cart_url||"/cart";window.location.pathname===cartUrl?window.location.reload():window.location.href=cartUrl;return}if(response.sections)this.cart.renderContents(response),publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form"});else return this.refreshCartSections();return}if(checkoutUrl){this.error=!1,window.location.assign(checkoutUrl);return}if(!this.cart){window.location=window.routes.cart_url;return}this.error||publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form"}),this.error=!1;const quickAddModal=this.closest("quick-add-modal");quickAddModal?(document.body.addEventListener("modalClosed",()=>{setTimeout(()=>{this.cart.renderContents(response)})},{once:!0}),quickAddModal.hide(!0),typeof AOS<"u"&&AOS.init()):(this.cart.renderContents(response),typeof AOS<"u"&&AOS.init())}).catch(e=>{console.error(e)}).finally(()=>{this.pending=!1,submitButton.classList.remove("loading"),this.cart&&this.cart.classList.contains("is-empty")&&this.cart.classList.remove("is-empty"),(!this.error||checkoutUrl)&&submitButton.removeAttribute("aria-disabled"),typeof AOS<"u"&&AOS.init()})}handleErrorMessage(errorMessage=!1){if(!this.hideErrors&&(this.errorMessageWrapper=this.errorMessageWrapper||this.querySelector(".product-form__error-message-wrapper"),!!this.errorMessageWrapper&&(this.errorMessage=this.errorMessage||this.errorMessageWrapper.querySelector(".product-form__error-message"),this.errorMessageWrapper.toggleAttribute("hidden",!errorMessage),errorMessage)))if(typeof errorMessage=="object"){const formattedMessage=Object.entries(errorMessage).map(([field,messages])=>`${field}: ${messages.join(", ")}`).join(" | ");this.errorMessage.textContent=formattedMessage}else this.errorMessage.textContent=errorMessage}});let removedElements={mobile:[],desktop:[]};removeElementsByScreenSize2(),window.addEventListener("resize",removeElementsByScreenSize2),window.addEventListener("shopify:section:select",removeElementsByScreenSize2)}class StickyAddToCart extends HTMLElement{constructor(){super(),this._handleResize=this._debounce(this.initStickyAddToCart.bind(this),200)}connectedCallback(){this.initStickyAddToCart(),window.addEventListener("resize",this._handleResize)}disconnectedCallback(){window.removeEventListener("resize",this._handleResize)}initStickyAddToCart(){const img=this.querySelector(".product-content img"),selectField=this.querySelector('select[name="id"]'),addButton=this.querySelector('button[name="add"]'),productForm=document.querySelector(".product-form");if(!selectField||!addButton||!productForm)return;const addToCartText=addButton.getAttribute("data-add-to-cart"),soldOutText=addButton.getAttribute("data-sold-out"),checkVisibility=()=>{const formRect=productForm.getBoundingClientRect(),footerRect=document.querySelector("footer")?.getBoundingClientRect(),isOutOfView=formRect.bottom<=0,isFooterVisible=footerRect&&footerRect.top<window.innerHeight;isOutOfView&&!isFooterVisible?(this.classList.add("show"),document.documentElement.style.paddingBottom=`${this.clientHeight}px`):(this.classList.remove("show"),document.documentElement.style.paddingBottom="0")};checkVisibility(),window.addEventListener("scroll",checkVisibility),selectField.addEventListener("change",()=>{const selectedOption=selectField.options[selectField.selectedIndex];selectedOption.dataset.img&&img.setAttribute("src",selectedOption.dataset.img),selectedOption.getAttribute("data-available")==="false"?(addButton.setAttribute("disabled","true"),addButton.querySelector("span").textContent=soldOutText):(addButton.removeAttribute("disabled"),addButton.querySelector("span").textContent=addToCartText)}),document.querySelector('.product-form [name="id"]')?.addEventListener("change",e=>{const value=Number(e.target.value);value&&(selectField.value=value)})}_debounce(func,wait){let timeout;return(...args)=>{clearTimeout(timeout),timeout=setTimeout(()=>func.apply(this,args),wait)}}}customElements.define("sticky-add-to-cart",StickyAddToCart);class IngredientDetails extends HTMLElement{constructor(){super()}connectedCallback(){let content=this.innerHTML;content=content.replace(/<\/?p>/g,""),content=content.replace(/<br\s*\/?>/g,"|||BR|||");let rows=content.split("|||BR|||").map(row=>row.trim()).filter(row=>row.length>0);this.innerHTML="",rows.forEach((row,index)=>{setTimeout(()=>{let isIndented=!1;row.startsWith("-")&&(row=row.substring(1).trim(),isIndented=!0);const useAlternativeFormat=document.querySelector("[data-ingredient-format]").dataset.ingredientFormat==="true";let columns=row.split(useAlternativeFormat?"#":",").map(col=>col.trim()),rowElement=document.createElement("span");rowElement.classList.add("ingredient-details-content"),isIndented&&rowElement.classList.add("indented"),columns.forEach(col=>{let colElement=document.createElement("span");colElement.innerHTML=col,rowElement.appendChild(colElement)}),this.appendChild(rowElement)},index*30)})}}customElements.define("ingredient-details",IngredientDetails);
//# sourceMappingURL=/cdn/shop/t/57/assets/product-form.js.map?v=92355462816923179181785731888

// Joyprotyn Ajax purchase, replay protection, and subscription-readiness guard.
// Native product forms are added through the Ajax Cart API before a GET redirect,
// so browser refresh/back/forward cannot replay a /cart/add navigation POST.
(() => {
  if (window.jpPurchaseSubmitGuardReady) return;
  window.jpPurchaseSubmitGuardReady = true;
  window.jpCheckoutSubmitGuardReady = true;
  window.jpSubscriptionReadinessGuardReady = true;

  const checkoutButtonSelector = [
    "[data-checkout]",
    "[data-checkout-url]",
    'button[name="return_to"][value="/checkout"]',
    'input[name="return_to"][value="/checkout"]',
  ].join(",");
  const addToCartButtonSelector = [
    "[data-add-to-cart]",
    '.jp-product-form button[type="submit"][name="add"]',
  ].join(",");
  const purchaseButtonSelector = [
    checkoutButtonSelector,
    addToCartButtonSelector,
  ].join(",");
  const lockedState = "jpPurchaseSubmitting";
  const subscriptionShellSelector = "[data-jpvs-seal-shell]";
  const subscriptionOptionSelector =
    ".sealsubs-container .sls-option-container input.sls-option";
  const subscriptionReadinessTimeoutMs = 8000;
  const subscriptionRetryTimeoutMs = 8000;

  const ensurePurchaseGuardStyles = () => {
    if (document.getElementById("jp-subscription-guard-styles")) return;

    const style = document.createElement("style");
    style.id = "jp-subscription-guard-styles";
    style.textContent = `
      .jp-subscription-guard-notice[hidden]{display:none!important}
      .jp-subscription-guard-notice{display:grid;gap:10px;margin:0;padding:12px 14px;border:1px solid #e4b386;border-radius:8px;background:#fff8f1;color:#3a2a1f;font:inherit;line-height:1.45}
      .jp-subscription-guard-notice.is-error{border-color:#dc9b70;background:#fff4ee}
      .jp-subscription-guard-message{margin:0;font-size:14px;font-weight:750}
      .jp-subscription-guard-actions{display:flex;flex-wrap:wrap;gap:8px}
      .jp-subscription-guard-actions button{min-height:40px;margin:0;padding:8px 14px;border-radius:7px;font:inherit;font-size:14px;font-weight:800;line-height:1.2;cursor:pointer}
      .jp-subscription-guard-actions button:disabled{cursor:wait;opacity:.65}
      .jp-subscription-guard-retry{border:1px solid #e55318;background:#f05a1a;color:#fff}
      .jp-subscription-guard-refresh{border:1px solid #b7aa9d;background:#fff;color:#2e3d33}
      .jp-purchase-ajax-error[hidden]{display:none!important}
      .jp-purchase-ajax-error{margin:12px 0 0;color:#b42318;font:inherit;font-size:14px;line-height:1.45}
      button.is-checkout-submitting{position:relative!important;font-size:0!important;text-shadow:none!important}
      button.is-checkout-submitting>*{visibility:hidden!important}
      button.is-checkout-submitting::after{content:attr(data-jp-processing-label);position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding:0 12px;color:var(--jp-processing-color,#fff);font-family:inherit;font-size:var(--jp-processing-font-size,14px);font-weight:inherit;line-height:1;letter-spacing:inherit;text-align:center;text-transform:inherit;white-space:nowrap;pointer-events:none}
    `;
    (document.head || document.documentElement).appendChild(style);
  };

  const subscriptionState = (form) => {
    const shell = form?.querySelector?.(subscriptionShellSelector);

    if (!shell) return { managed: false, ready: true, failed: false };

    const options = shell.querySelectorAll(subscriptionOptionSelector);
    const selectedOption = shell.querySelector(`${subscriptionOptionSelector}:checked`);
    let ready =
      shell.classList.contains("is-ready")
      && options.length > 0
      && selectedOption;

    if (ready) {
      const sellingPlan = String(new FormData(form).get("selling_plan") || "").trim();
      ready = selectedOption.value === "one_time" ? !sellingPlan : Boolean(sellingPlan);
    }

    return {
      managed: true,
      ready: Boolean(ready),
      failed: shell.classList.contains("is-timeout") && !ready,
      shell,
    };
  };

  const subscriptionRetryStorageKey = (shell) => {
    const productId = shell
      .querySelector("[data-product-id]")
      ?.getAttribute("data-product-id") || "product";
    return `jpSubscriptionRetry:${window.location.pathname}:${productId}`;
  };

  const persistedRetryAttempts = (shell) => {
    try {
      return Number(window.sessionStorage.getItem(subscriptionRetryStorageKey(shell)) || 0);
    } catch (error) {
      return 0;
    }
  };

  const persistRetryAttempts = (shell, attempts) => {
    try {
      window.sessionStorage.setItem(subscriptionRetryStorageKey(shell), String(attempts));
    } catch (error) {
      // The guard still works when storage is unavailable.
    }
  };

  const clearPersistedRetryAttempts = (shell) => {
    try {
      window.sessionStorage.removeItem(subscriptionRetryStorageKey(shell));
    } catch (error) {
      // The guard still works when storage is unavailable.
    }
  };

  const ensureSubscriptionNotice = (form) => {
    let notice = form.querySelector("[data-jp-subscription-guard-notice]");
    if (notice) return notice;

    const shell = form.querySelector(subscriptionShellSelector);
    if (!shell) return null;

    ensurePurchaseGuardStyles();
    notice = document.createElement("div");
    notice.className = "jp-subscription-guard-notice";
    notice.dataset.jpSubscriptionGuardNotice = "";
    notice.hidden = true;
    notice.tabIndex = -1;
    notice.innerHTML = `
      <p class="jp-subscription-guard-message" data-jp-subscription-guard-message></p>
      <div class="jp-subscription-guard-actions">
        <button class="jp-subscription-guard-retry" type="button" data-jp-subscription-retry>Try again</button>
        <button class="jp-subscription-guard-refresh" type="button" data-jp-subscription-refresh hidden>Refresh page</button>
      </div>
    `;
    shell.insertAdjacentElement("afterend", notice);

    notice
      .querySelector("[data-jp-subscription-retry]")
      .addEventListener("click", () => retrySubscription(form));
    notice
      .querySelector("[data-jp-subscription-refresh]")
      .addEventListener("click", () => window.location.reload());

    return notice;
  };

  const showSubscriptionNotice = (form, mode, focusNotice = false) => {
    const notice = ensureSubscriptionNotice(form);
    const shell = form.querySelector(subscriptionShellSelector);
    if (!notice || !shell) return;

    const message = notice.querySelector("[data-jp-subscription-guard-message]");
    const retryButton = notice.querySelector("[data-jp-subscription-retry]");
    const refreshButton = notice.querySelector("[data-jp-subscription-refresh]");
    const retryAttempts = Number(shell.dataset.jpSubscriptionRetryAttempts || 0);
    const failed = mode === "failed";
    const retrying = mode === "retrying";

    notice.hidden = false;
    notice.classList.toggle("is-error", failed);
    notice.setAttribute("role", failed ? "alert" : "status");
    notice.setAttribute("aria-live", failed ? "assertive" : "polite");
    message.textContent = failed
      ? "We couldn't load the purchase options. Please try again."
      : mode === "retrying"
        ? "Reloading purchase options…"
        : "Purchase options are still loading. Please wait a moment and try again.";
    retryButton.hidden = !failed && !retrying;
    retryButton.disabled = retrying;
    retryButton.textContent = retrying ? "Trying again…" : "Try again";
    refreshButton.hidden = !failed || retryAttempts < 1;

    if (focusNotice) {
      window.requestAnimationFrame(() => notice.focus({ preventScroll: true }));
    }
  };

  const hideSubscriptionNotice = (form) => {
    const notice = form.querySelector("[data-jp-subscription-guard-notice]");
    if (notice) notice.hidden = true;
  };

  const finishSubscriptionRetry = (form) => {
    const state = subscriptionState(form);
    if (!state.managed || !state.ready) return false;

    window.clearTimeout(state.shell.jpSubscriptionRetryTimer);
    window.clearTimeout(state.shell.jpSubscriptionReadinessTimer);
    delete state.shell.jpSubscriptionRetryTimer;
    delete state.shell.jpSubscriptionReadinessTimer;
    delete state.shell.dataset.jpSubscriptionRetrying;
    if (state.shell.classList.contains("is-timeout")) {
      state.shell.classList.remove("is-timeout");
    }
    if (state.shell.getAttribute("aria-busy") !== "false") {
      state.shell.setAttribute("aria-busy", "false");
    }
    clearPersistedRetryAttempts(state.shell);
    hideSubscriptionNotice(form);
    return true;
  };

  const failSubscriptionRetry = (form) => {
    const state = subscriptionState(form);
    if (!state.managed || state.ready) {
      finishSubscriptionRetry(form);
      return;
    }

    window.clearTimeout(state.shell.jpSubscriptionRetryTimer);
    window.clearTimeout(state.shell.jpSubscriptionReadinessTimer);
    delete state.shell.jpSubscriptionRetryTimer;
    delete state.shell.jpSubscriptionReadinessTimer;
    delete state.shell.dataset.jpSubscriptionRetrying;
    state.shell.classList.add("is-timeout");
    state.shell.setAttribute("aria-busy", "false");
    showSubscriptionNotice(form, "failed");
  };

  function retrySubscription(form) {
    const state = subscriptionState(form);
    if (!state.managed || state.ready || state.shell.dataset.jpSubscriptionRetrying === "true") {
      finishSubscriptionRetry(form);
      return;
    }

    const attempts = Number(state.shell.dataset.jpSubscriptionRetryAttempts || 0) + 1;

    state.shell.dataset.jpSubscriptionRetryAttempts = String(attempts);
    persistRetryAttempts(state.shell, attempts);
    state.shell.dataset.jpSubscriptionRetrying = "true";
    state.shell.classList.remove("is-ready", "is-timeout");
    state.shell.setAttribute("aria-busy", "true");
    showSubscriptionNotice(form, "retrying");
    window.clearTimeout(state.shell.jpSubscriptionReadinessTimer);
    delete state.shell.jpSubscriptionReadinessTimer;

    if (!window.SealSubs || typeof window.SealSubs.refresh !== "function") {
      const message = form.querySelector("[data-jp-subscription-guard-message]");
      if (message) message.textContent = "Reloading the page to restore purchase options…";
      window.setTimeout(() => window.location.reload(), 250);
      return;
    }

    try {
      window.SealSubs.refresh();
    } catch (error) {
      failSubscriptionRetry(form);
      return;
    }

    window.clearTimeout(state.shell.jpSubscriptionRetryTimer);
    state.shell.jpSubscriptionRetryTimer = window.setTimeout(
      () => failSubscriptionRetry(form),
      subscriptionRetryTimeoutMs
    );
  }

  const syncSubscriptionShell = (shell) => {
    const form = shell.closest("form");
    if (!form) return;

    if (finishSubscriptionRetry(form)) return;
    if (
      shell.classList.contains("is-timeout")
      && shell.dataset.jpSubscriptionRetrying !== "true"
    ) {
      showSubscriptionNotice(form, "failed");
    }
  };

  const initSubscriptionShell = (shell) => {
    if (shell.dataset.jpSubscriptionGuardBound === "true") {
      syncSubscriptionShell(shell);
      return;
    }

    shell.dataset.jpSubscriptionGuardBound = "true";
    const storedAttempts = persistedRetryAttempts(shell);
    if (storedAttempts > 0) {
      shell.dataset.jpSubscriptionRetryAttempts = String(storedAttempts);
    }
    const observer = new MutationObserver(() => syncSubscriptionShell(shell));
    observer.observe(shell, {
      attributes: true,
      attributeFilter: ["class", "aria-busy"],
      childList: true,
      subtree: true,
    });
    shell.jpSubscriptionGuardObserver = observer;
    shell.jpSubscriptionReadinessTimer = window.setTimeout(() => {
      const form = shell.closest("form");
      if (!form || finishSubscriptionRetry(form)) return;
      if (shell.dataset.jpSubscriptionRetrying === "true") return;

      shell.classList.add("is-timeout");
      shell.setAttribute("aria-busy", "false");
      showSubscriptionNotice(form, "failed");
    }, subscriptionReadinessTimeoutMs);
    syncSubscriptionShell(shell);
  };

  const initSubscriptionShells = (root = document) => {
    if (root.matches?.(subscriptionShellSelector)) initSubscriptionShell(root);
    root.querySelectorAll?.(subscriptionShellSelector).forEach(initSubscriptionShell);
  };

  const blockForSubscription = (event, form) => {
    const state = subscriptionState(form);
    if (!state.managed || state.ready) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    initSubscriptionShell(state.shell);
    showSubscriptionNotice(form, state.failed ? "failed" : "loading", true);
    return true;
  };

  const processingLabel = () => {
    const language = (document.documentElement.lang || "").toLowerCase();
    return language.startsWith("zh") ? "处理中…" : "Processing…";
  };

  const setProcessingState = (button) => {
    if (!(button instanceof HTMLButtonElement)) return;

    ensurePurchaseGuardStyles();
    const computedStyle = window.getComputedStyle(button);
    button.jpPurchasePreviousProcessingLabel = button.getAttribute(
      "data-jp-processing-label"
    );
    button.jpPurchasePreviousAriaLabel = button.getAttribute("aria-label");
    button.jpPurchasePreviousProcessingColor = {
      value: button.style.getPropertyValue("--jp-processing-color"),
      priority: button.style.getPropertyPriority("--jp-processing-color"),
    };
    button.jpPurchasePreviousProcessingFontSize = {
      value: button.style.getPropertyValue("--jp-processing-font-size"),
      priority: button.style.getPropertyPriority("--jp-processing-font-size"),
    };
    button.style.setProperty("--jp-processing-color", computedStyle.color);
    button.style.setProperty("--jp-processing-font-size", computedStyle.fontSize);
    button.setAttribute("data-jp-processing-label", processingLabel());
    button.setAttribute("aria-label", processingLabel());
    button.classList.add("is-checkout-submitting");
  };

  const restoreInlineProperty = (element, property, previous) => {
    if (previous?.value) {
      element.style.setProperty(property, previous.value, previous.priority || "");
    } else {
      element.style.removeProperty(property);
    }
  };

  const restoreProcessingState = (button) => {
    if (!(button instanceof HTMLButtonElement)) return;

    button.classList.remove("is-checkout-submitting");
    if (button.jpPurchasePreviousProcessingLabel === null) {
      button.removeAttribute("data-jp-processing-label");
    } else if (button.jpPurchasePreviousProcessingLabel !== undefined) {
      button.setAttribute(
        "data-jp-processing-label",
        button.jpPurchasePreviousProcessingLabel
      );
    }
    if (button.jpPurchasePreviousAriaLabel === null) {
      button.removeAttribute("aria-label");
    } else if (button.jpPurchasePreviousAriaLabel !== undefined) {
      button.setAttribute("aria-label", button.jpPurchasePreviousAriaLabel);
    }
    restoreInlineProperty(
      button,
      "--jp-processing-color",
      button.jpPurchasePreviousProcessingColor
    );
    restoreInlineProperty(
      button,
      "--jp-processing-font-size",
      button.jpPurchasePreviousProcessingFontSize
    );
    delete button.jpPurchasePreviousProcessingLabel;
    delete button.jpPurchasePreviousAriaLabel;
    delete button.jpPurchasePreviousProcessingColor;
    delete button.jpPurchasePreviousProcessingFontSize;
  };

  const unlock = (form) => {
    if (!form || form.dataset[lockedState] !== "true") return;

    const button = form.jpCheckoutLockedButton;
    delete form.dataset[lockedState];
    window.clearTimeout(form.jpCheckoutGuardTimer);
    delete form.jpCheckoutGuardTimer;
    delete form.jpCheckoutSubmitter;
    delete form.jpCheckoutLockedButton;

    if (!button) return;
    if (button.jpPurchasePreviousAriaBusy === null) {
      button.removeAttribute("aria-busy");
    } else if (button.jpPurchasePreviousAriaBusy !== undefined) {
      button.setAttribute("aria-busy", button.jpPurchasePreviousAriaBusy);
    } else {
      button.removeAttribute("aria-busy");
    }
    delete button.jpPurchasePreviousAriaBusy;
    restoreProcessingState(button);
    button.style.pointerEvents = button.jpCheckoutPreviousPointerEvents || "";
    delete button.jpCheckoutPreviousPointerEvents;
  };

  const cartErrorMessage = () => {
    if (typeof window.cartStrings?.error === "string" && window.cartStrings.error) {
      return window.cartStrings.error;
    }

    const language = (document.documentElement.lang || "").toLowerCase();
    return language.startsWith("zh")
      ? "更新购物车时出错，请重试。"
      : "There was an error while updating your cart. Please try again.";
  };

  const ensurePurchaseError = (form) => {
    let error = form.querySelector("[data-jp-purchase-ajax-error]");
    if (error) return error;

    error = document.createElement("p");
    error.className = "jp-purchase-ajax-error";
    error.dataset.jpPurchaseAjaxError = "";
    error.hidden = true;
    error.tabIndex = -1;
    error.setAttribute("role", "alert");
    error.setAttribute("aria-live", "assertive");
    form.appendChild(error);
    return error;
  };

  const hidePurchaseError = (form) => {
    const error = form.querySelector("[data-jp-purchase-ajax-error]");
    if (!error) return;

    error.hidden = true;
    error.textContent = "";
  };

  const showPurchaseError = (form, message) => {
    const error = ensurePurchaseError(form);
    error.textContent = typeof message === "string" && message
      ? message
      : cartErrorMessage();
    error.hidden = false;
    window.requestAnimationFrame(() => error.focus({ preventScroll: true }));
  };

  const cartAddAjaxUrl = () => {
    const route = String(window.routes?.cart_add_url || "/cart/add");
    const queryIndex = route.indexOf("?");
    const path = queryIndex === -1 ? route : route.slice(0, queryIndex);
    const query = queryIndex === -1 ? "" : route.slice(queryIndex);
    return `${path.endsWith(".js") ? path : `${path}.js`}${query}`;
  };

  const purchaseDestination = (submitter) => {
    if (submitter.matches(checkoutButtonSelector)) {
      return submitter.dataset.checkoutUrl
        || submitter.getAttribute("value")
        || "/checkout";
    }

    return window.routes?.cart_url || "/cart";
  };

  const responseErrorMessage = (payload) => {
    if (!payload || typeof payload !== "object") return cartErrorMessage();
    const candidate = payload.description || payload.message || payload.errors;
    return typeof candidate === "string" && candidate
      ? candidate
      : cartErrorMessage();
  };

  const submitNativePurchaseWithAjax = async (form, submitter) => {
    const formData = new FormData(form);
    formData.delete("return_to");

    try {
      const response = await fetch(cartAddAjaxUrl(), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "same-origin",
        body: formData,
      });
      let payload;

      try {
        payload = await response.json();
      } catch {
        throw new Error(cartErrorMessage());
      }

      if (!response.ok || payload?.status) {
        throw new Error(responseErrorMessage(payload));
      }

      window.location.assign(purchaseDestination(submitter));
    } catch (error) {
      console.error("Joyprotyn Ajax purchase failed", error);
      unlock(form);
      showPurchaseError(form, error?.message);
    }
  };

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target instanceof Element
        ? event.target.closest(purchaseButtonSelector)
        : null;
      const form = target?.form;

      if (!form) return;
      if (blockForSubscription(event, form)) return;
      if (form.dataset[lockedState] === "true") {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      form.jpCheckoutSubmitter = target;
      window.setTimeout(() => {
        if (
          form.dataset[lockedState] !== "true"
          && form.jpCheckoutSubmitter === target
        ) {
          delete form.jpCheckoutSubmitter;
        }
      }, 0);
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const submitter = event.submitter
        || form.jpCheckoutSubmitter
        || form.querySelector(purchaseButtonSelector);
      if (!submitter?.matches?.(purchaseButtonSelector)) return;
      if (blockForSubscription(event, form)) return;

      if (form.dataset[lockedState] === "true") {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      // The theme component already owns its Ajax request and pending state.
      if (form.closest("product-form")) {
        return;
      }

      // Take ownership before any target/bubble listener or native navigation.
      // This removes /cart/add POST requests from browser navigation history.
      event.preventDefault();
      event.stopImmediatePropagation();
      hidePurchaseError(form);

      form.dataset[lockedState] = "true";
      form.jpCheckoutLockedButton = submitter;
      delete form.jpCheckoutSubmitter;
      submitter.jpCheckoutPreviousPointerEvents = submitter.style.pointerEvents;
      submitter.jpPurchasePreviousAriaBusy = submitter.getAttribute("aria-busy");
      submitter.style.pointerEvents = "none";
      submitter.setAttribute("aria-busy", "true");
      setProcessingState(submitter);

      // Recovery path if validation, an app, or the network prevents navigation.
      form.jpCheckoutGuardTimer = window.setTimeout(() => unlock(form), 30000);
      void submitNativePurchaseWithAjax(form, submitter);
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initSubscriptionShells(), {
      once: true,
    });
  } else {
    initSubscriptionShells();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSubscriptionShells(event.target);
  });

  window.addEventListener("pageshow", () => {
    document
      .querySelectorAll('form[data-jp-purchase-submitting="true"]')
      .forEach(unlock);
  });
})();
